// extracted by mini-css-extract-plugin
export var completionBody = "_kn-2";
export var completionCard = "_kn-0";
export var completionFooter = "_kn-3";
export var completionTitle = "_kn-1";